var styles = {
  "TopBar": "Online-Store-UI-TopBar_3tnbt",
  "loading": "Online-Store-UI-TopBar--loading_vo6ie",
  "slim": "Online-Store-UI-TopBar--slim_1kqca",
  "usesBottomSheet": "Online-Store-UI-TopBar--usesBottomSheet_qvlkc",
  "LoadingSkeleton": "Online-Store-UI-TopBar__LoadingSkeleton_1eq5y"
};

export { styles as default };
